import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mx-footer">
      <div className="mx-footer-brand">
        <img src="/media/images/logo-flame-mark.png" alt="" />
        <span className="mx-footer-copy">MachineX America LLC<br />5900 Balcones Drive, Suite 100<br />Austin, TX 78731</span>
      </div>
      <nav className="mx-footer-nav" aria-label="Footer">
        <Link to="/industries">Industries</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
      </nav>
      <div className="mx-footer-email">info@machinexamerica.com</div>
    </footer>
  );
}
